import { render, staticRenderFns } from "./DestinationStickyMenu.vue?vue&type=template&id=6032bad0&"
import script from "./DestinationStickyMenu.vue?vue&type=script&lang=ts&"
export * from "./DestinationStickyMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DestinationStickyMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports